















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'


@Component
export default class TemplateField extends Vue {
    @Prop() value!: string
    rules = [(v: string): boolean | string => v.length <= 500 || 'Max 500 characters']

    @Emit('input')
    handleInput(template: string): string {
        return template
    }
}
